//属性数据
export const attribute = {
  account: [
    // { label: "广告账户ID", value: "advertiserId" },
    // { label: "广告账户名称", value: "advertiserName" },
    { label: "产品", value: "productName" },
    { label: "授权状态", value: "status" },
    { label: "优化师", value: "optimizer" },
    { label: "账户余额", value: "balance" },
    { label: "预算(元)", value: "dailyBudget", width: "140" },
  ],
  plan: [
    // { label: "推广计划名称", value: "campaignName" },
    { label: "推广计划ID", value: "campaignId" },
    { label: "广告账户名称", value: "advertiserName" },
    { label: "广告账户ID", value: "advertiserId" },
    { label: "推广目标", value: "promotedObjectType" },
    { label: "状态", value: "dataStatus" },
    { label: "创建时间", value: "campaignCreateTime" },
    { label: "预算(元)", value: "dailyBudget" },
    { label: "投放方式", value: "speedMode" },
  ],
  adGroup: [
    // { label: "广告组名称", value: "adName" },
    { label: "广告组ID", value: "adId" },
    { label: "状态", value: "dataStatus" },
    { label: "产品", value: "productName" },
    { label: "推广计划名称", value: "campaignName" },
    { label: "推广计划ID", value: "campaignId" },
    { label: "广告账户名称", value: "advertiserName" },
    { label: "广告账户ID", value: "advertiserId" },
    { label: "推广目标", value: "promotedObjectType" },
    { label: "出价", value: "bidAmount" },
    { label: "优化方式", value: "optimizationGoal" },
    { label: "开始时间", value: "beginDate" },
    { label: "结束时间", value: "endDate" },
    { label: "账户余额(元)", value: "balance" },
    { label: "预算(元)", value: "dailyBudget" },
  ],
  creative: [
    // { label: "创意名称", value: "creativeName" },
    // { label: "创意ID", value: "creativeId" },
    // { label: "广告创意", value: "title" },
    { label: "状态", value: "dataStatus" },
    { label: "产品", value: "productName" },
    { label: "创意方式", value: "isDynamicCreative" },
    { label: "广告名称", value: "adName" },
    { label: "广告ID", value: "adId" },
    { label: "广告账户名称", value: "advertiserName" },
    { label: "广告账户ID", value: "advertiserId" },
    { label: "推广计划名称", value: "campaignName" },
    { label: "推广计划ID", value: "campaignId" },
  ],
};

// 基础数据
export const baseData = [
  { label: "展示数", value: "showCnt" },
  { label: "点击数", value: "clickCnt" },
  { label: "点击率", value: "ctr" },
  { label: "点击成本(元)", value: "cpc" },
  { label: "千次展示成本(元)", value: "thousandDisplayPrice" },
  { label: "花费(元)", value: "cost" },
  { label: "可转化点击数", value: "attributionConvert" },
  { label: "可转化点击率", value: "attributionConvertRate" },
  { label: "可转化点击成本(元)", value: "attributionConvertCost" },
];

// APP数据
export const appData = [
  { label: "目标转化数", value: "convertCnt" },
  { label: "目标转化率", value: "convertCntRate" },
  { label: "目标转化成本(元)", value: "convertCntCost" },
  { label: "深度转化数", value: "deepConvert" },
  { label: "深度目标转化率", value: "deepConversionsRate" },
  { label: "深度转化成本(元)", value: "deepConversionsCost" },
  // { label: "付费行为数", value: "pay_count" },
  // { label: "付费金额(元)", value: "active_pay_cost" },
  // { label: "付费行为成本(元)", value: "active_pay_rate" },
  // { label: "点击付费行为率", value: "attribution_convert_cost" },
  // { label: "激活付费行为率", value: "attribution_deep_convert" },
  { label: "下载数", value: "downloadFinish" },
  { label: "下载率", value: "downloadRate" },
  { label: "下载成本(元)", value: "downloadCost" },
  { label: "安装数", value: "installFinish" },
  { label: "安装成本(元)", value: "installCost" },
  { label: "安装率", value: "installRate" },
  { label: "激活数", value: "activeCnt" },
  { label: "下载激活率", value: "activatedRate" },
  { label: "点击激活率", value: "clickActivatedRate" },
  { label: "激活成本(元)", value: "activatedCost" },
  { label: "次日留存人数", value: "attributionNextDayOpenCnt" },
  { label: "次日留存率", value: "retentionRate" },
  { label: "次日留存成本", value: "retentionCost" },
];
